import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

import { API_URL } from '../constants'

const exportEvents = async (id: string): Promise<{ data: Blob; filename: string }> => {
  const url = `${API_URL}/campaigns/${id}/export-events`
  const { data } = await axios.get(url, {
    withCredentials: true,
    responseType: 'blob',
  })
  const filename = `Campaign events ${id}.csv`

  return { data, filename }
}

export const useExportEvents = () => {
  return useMutation({
    mutationFn: exportEvents,
    onSuccess: async ({ data, filename }) => {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(data)
      link.download = filename
      link.click()
      URL.revokeObjectURL(link.href)
    },
  })
}
